<template>
  <client-information
    v-model="customer"
    :add-customers-flag="useFeature('add_customers')"
    :show-unassign="isAssignedToStylist && !isAdminMode"
    :readonly="!useFeature('modify_customer_details')"
    @delete-group="deleteGroup"
    @change-avatar="changeAvatar"
    @delete-avatar="deleteAvatar"
    @unassign="onUnassign"
    @delete-customer="deleteCustomer"
    @subscriptionChange="onSubscriptionChange"
  >
    <profile-selector-container
      v-if="isAdminMode"
      :customer="customer"
    />
  </client-information>
</template>
<script>
import { EventBus } from '@/event-bus';
import ClientInformation from './ClientInformation';
import ProfileSelectorContainer from './ProfileSelectorContainer';

export default {
  name: 'ClientInformationContainer',
  components: {
    ClientInformation,
    ProfileSelectorContainer,
  },
  computed: {
    customer: {
      get() {
        return this.$store.state.customers.item;
      },
      set(data) {
        this.$store.dispatch('customers/patchCustomerInfo', data);
      },
    },
    isAssignedToStylist() {
      // True if this customer is assigned to the current logged profile's team
      const { profile } = this.$store.state.account.user;
      return this.customer.assigned_to === profile.pk;
    },
    isAdminMode() {
      return this.$store.state.account.isAdminMode;
    },
  },
  methods: {
    changeAvatar(image) {
      EventBus.$emit('avatar-editor--close');
      this.$store.dispatch('customers/patchCustomerImage', {
        image,
        profile_pic: image,
        id: this.customer.pk,
      });
    },
    deleteAvatar() {
      EventBus.$emit('avatar-editor--close');
      this.$store.dispatch('customers/patchCustomerInfo', {
        pk: this.customer.pk,
        image: null,
      });
    },
    patchCustomer(payload) {
      this.$store.dispatch('customers/patchCustomerInfo', payload);
    },
    deleteGroup(group) {
      this.$store.dispatch('customers/deleteGroupMember', {
        customer: this.customer.pk,
        id: group.pk,
      });
    },
    deleteCustomer() {
      if (!this.isAdminMode) {
        console.warn('Non admin tried to delete the customer!');
        return;
      }
      EventBus.$emit('confirm', {
        title: 'Delete Client?',
        message: `You are about to delete the client ${this.customer.first_name} ${this.customer.last_name}.`,
        positiveText: 'Delete',
        // negativeText: 'Cancel',
        // reverse: true,
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('customers/deleteCustomer', { id: this.customer.pk, scope: this.$store.getters['account/scope'] })
              .then(() => {
                this.$router.push('/clients').then(() => {
                  EventBus.$emit('toast-success', 'Client successfully removed.');
                });
              }).catch((error) => {
                console.log('error deleting customer:', error);
                EventBus.$emit('toast-error', 'Unable to remove client. Please try again.');
              });
          }
        },
      });
    },
    onUnassign() {
      if (!this.isAssignedToStylist) {
        console.warn("Tried to unassign customer that's not associated to this profile's team!");
        return;
      }
      EventBus.$emit('confirm', {
        title: 'Unassign Client',
        message: `Are you sure you want to remove this client from your client list? You will not
         be able to see their client profile or email them unless they are reassigned to you.`,
        positiveText: 'Confirm',
        // negativeText: 'Cancel',
        // reverse: true,
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('customers/patchCustomerInfo', {
              pk: this.customer.pk,
              assigned_to: null,
            }).then(() => {
              this.$router.push('/clients').then(() => {
                EventBus.$emit('toast-success', 'Client successfully removed.');
              });
            }).catch(() => {
              EventBus.$emit('toast-error', 'Unable to remove client. Please try again.');
            });
          }
        },
      });
    },
    onSubscriptionChange(event) {
      const loggedIn = this.$store.state.account.user;

      this.$mixpanel.track('subscription_change', {
        account_id: loggedIn.user.email,
        suscription: event.label,
      });
      const payload = {
        pk: this.$route.params.customerId,
        unsubscribed: event.value,
        scope: this.$store.getters['accounts/scope'],
      };
      this.$store.dispatch('customers/changeSubscription', payload);
    },
  },
};
</script>
<style lang="scss"
  scoped>
</style>
